export default {"src":"/_next/static/media/professional-seller.a21e240b.svg","height":96,"width":96,"blurWidth":0,"blurHeight":0};